import decode from 'jwt-decode';
import http from '@/utils/axios';

const JWT_TOKEN = 'JWT_TOKEN';

export function storeToken(token) {
    decode(token);
    localStorage.setItem(JWT_TOKEN, token);
}

export function getDetails() {
    if (getToken()) {
        return decode(getToken());
    }
    return null;
}

export function getRoles() {
    let x = getDetails();
    if (x && x.roles) {
        return x.roles;
    }
    return [];
}

export function getToken() {
    return localStorage.getItem(JWT_TOKEN);
}

export function isAuthenticated() {
    return !!getToken() && !hasExpired(getToken());
}

export function deleteToken() {
    localStorage.removeItem(JWT_TOKEN);
    delete http.defaults.headers.common.Authorization;
}

export function getTokenExpirationDate(encodedToken) {
    const token = decode(encodedToken);
    if (!token.exp) {
        return null;
    }

    const date = new Date(0);

    date.setUTCSeconds(token.exp);
    return date;
}
export function hasExpired(token) {
    const expirationDate = getTokenExpirationDate(token);
    return expirationDate < new Date();
}

